import { newE2EPage } from "@stencil/core/testing";

describe("checkbox-rules", () => {
    it("should render a component", async () => {
        const page = await newE2EPage();
        await page.setContent(`<ux-checkbox-rules></ux-checkbox-rules>`);
        const el = await page.find("ux-checkbox-rules");
        await page.waitForChanges();
        expect(el).toHaveClass("hydrated");
    });

    it("should check and uncheck required checkboxes correctly", async () => {
        const page = await newE2EPage();
        await page.setContent(
            `<ux-checkbox-rules>
                <ux-checkbox name="foo" label="Foo" value="foo" input-id="test-checkbox-foo"></ux-checkbox>
                <ux-checkbox name="bar" label="Bar" value="bar" input-id="test-checkbox-bar"></ux-checkbox>
                <ux-checkbox
                    name="baz"
                    label="Baz"
                    value="baz"
                    input-id="test-checkbox-baz"
                    data-ux-checkbox-rules-require="foo,bar"
                ></ux-checkbox>
            </ux-checkbox-rules>`
        );
        const uxCheckboxChange = await page.spyOnEvent("uxCheckboxChange");
        await page.waitForChanges();
        const el = await page.find("ux-checkbox-rules");

        const checkboxFoo = await page.find("ux-checkbox[name=foo]");
        const checkboxBar = await page.find("ux-checkbox[name=bar]");
        const checkboxBaz = await page.find("ux-checkbox[name=baz]");

        expect(await checkboxFoo.getProperty("checked")).toBeFalsy();
        expect(await checkboxBar.getProperty("checked")).toBeFalsy();
        expect(await checkboxBaz.getProperty("checked")).toBeFalsy();

        // Check checkbox without rules
        await checkboxFoo.click();
        await page.waitForChanges();
        expect(uxCheckboxChange).toHaveReceivedEventDetail({
            checked: true,
            inputId: "test-checkbox-foo",
            name: "foo",
            value: "foo"
        });
        expect(await checkboxFoo.getProperty("checked")).toBeTruthy();

        // Check checkbox with rules
        await checkboxBaz.click();
        await page.waitForChanges();

        expect(uxCheckboxChange).toHaveReceivedEventDetail({
            checked: true,
            inputId: "test-checkbox-baz",
            name: "baz",
            value: "baz"
        });

        // Foo and Bar should be checked because of the required rule assigned to Baz
        expect(await checkboxFoo.getProperty("checked")).toBeTruthy();
        expect(await checkboxBar.getProperty("checked")).toBeTruthy();
        expect(await checkboxBaz.getProperty("checked")).toBeTruthy();

        // Uncheck checkbox with rules
        await checkboxBaz.click();
        await page.waitForChanges();

        expect(uxCheckboxChange).toHaveReceivedEventDetail({
            checked: false,
            inputId: "test-checkbox-baz",
            name: "baz",
            value: "baz"
        });

        // Foo should stay checked as it was already checked before
        expect(await checkboxFoo.getProperty("checked")).toBeTruthy();
        expect(await checkboxBar.getProperty("checked")).toBeFalsy();
        expect(await checkboxBaz.getProperty("checked")).toBeFalsy();

        expect(el).toMatchSnapshot();
    });
});
